import React from "react";

export default () => (
  <section id="works">
    <div className="section_hexagon" />
    <div className="section_title">
      <p>WORKS</p>
      <h2>ソルパックが持つソリューション</h2>
    </div>
    <div className="section_contents">
      <div className="works_list">
        <div className="works_item">
          <a className="item" href="https://www.solpac.co.jp/products/GoAnywhere/" target="blank" rel="noopener noreferrer">
            <div className="image">
              <img src="/~/media/Images/corporate/home/mainvisual/origin-product-go_anywhere_mft.ashx" alt="true" />
            </div>
            <div className="text">
              <p className="title">
                GoAnywhere
              </p>
              <p className="description">
                企業内で起こり得る全ての「ファイル転送」「ファイル共有」をカバーするオールインワンソリューション
              </p>
            </div>
          </a>
        </div>
        <div className="works_item">
          <a className="item" href="https://www.solpac.co.jp/service/powersystems/" target="blank" rel="noopener noreferrer">
            <div className="image">
              <img src="/~/media/Images/corporate/service/powersystems/origin-service_powersystems.ashx" alt="true" />
            </div>
            <div className="text">
              <p className="title">IBMi(AS/400)サービス</p>
              <p className="description">多種多様な課題と解決策をご提案！</p>
            </div>
          </a>
        </div>
        <div className="works_item">
          <a className="item" href="https://www.solpac.co.jp/products/WinActor/lp/index.html" target="blank" rel="noopener noreferrer">
            <div className="image">
              <img src="/~/media/Images/corporate/home/mainvisual/origin-service-winactor-s.ashx" alt="true" />
            </div>
            <div className="text">
              <p className="title">
                WinActor
              </p>
              <p className="description">
                Windows端末での単純作業をRPA(自動化)が代行します。本ソフトに関する研修ができるのは国内で2社だけ！
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div className="works_more">
      <div className="more_box">
        <a
          className="external"
          rel="noopener noreferrer"
          href="https://www.solpac.co.jp/case/"
          target="_block"
        >
          導入事例の一覧へ
        </a>
      </div>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/Home/Works.js